import { Editable, IconButton } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { LuCheck, LuPencilLine, LuX } from 'react-icons/lu'

interface EditableFieldProps {
  text: string
  onSubmit: (value: string) => void
}

export const EditableField: FC<EditableFieldProps> = ({ text, onSubmit }) => {
  const [inputValue, setInputValue] = useState(text)

  useEffect(() => {
    setInputValue(text)
  }, [text])

  return (
    <Editable.Root
      maxLength={30}
      value={inputValue}
      activationMode='dblclick'
      onValueChange={({ value }) => setInputValue(value)}
      onValueCommit={() => onSubmit(inputValue)}>
      <Editable.Preview />
      <Editable.Input />
      <Editable.Control>
        <Editable.EditTrigger asChild>
          <IconButton variant='ghost' size='xs'>
            <LuPencilLine />
          </IconButton>
        </Editable.EditTrigger>
        <Editable.CancelTrigger asChild>
          <IconButton variant='outline' size='xs'>
            <LuX />
          </IconButton>
        </Editable.CancelTrigger>
        <Editable.SubmitTrigger asChild disabled={inputValue.length === 0}>
          <IconButton variant='outline' size='xs'>
            <LuCheck />
          </IconButton>
        </Editable.SubmitTrigger>
      </Editable.Control>
    </Editable.Root>
  )
}
